/**
 * Converts a kebab-case string to PascalCase (each segment capitalized, concatenated).
 * Empty segments from duplicate or leading/trailing hyphens are ignored.
 */
export function kebabToPascalCase(value: string | null | undefined): string {
  if (value == null || value === '') {
    return '';
  }

  return String(value)
    .split('-')
    .filter(part => part.length > 0)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}
